export enum Sizes {
    SMALL = 'S',

    MEDIUM = 'M',
    
    LARGE= 'L'
}